import { AiUsagePeriod, AiUsageSource, AiUsageTab } from "@/types/admin/ai-usage";

export const AI_USAGE_TABS: AiUsageTab[] = [
  { id: "usage", label: "Usage", genieIcon: "trending-up" },
  { id: "models", label: "Models by feature", genieIcon: "brain" },
];

export const DEFAULT_TAB = "usage";

export const PERIOD_OPTIONS: { value: AiUsagePeriod; label: string }[] = [
  { value: "7d", label: "Last 7 days" },
  { value: "30d", label: "Last 30 days" },
  { value: "90d", label: "Last 90 days" },
];

export const SOURCE_LABELS: Record<AiUsageSource, string> = {
  edge: "Edge function",
  workflow: "GitHub workflow",
};

export const SOURCE_COLORS: Record<AiUsageSource, string> = {
  edge: "#4E9CFF",
  workflow: "#FF4DB8",
};

export const PROVIDER_LABELS: Record<string, string> = {
  anthropic: "Anthropic",
  openai: "OpenAI",
  gemini: "Google",
  openrouter: "OpenRouter",
};

const compact = new Intl.NumberFormat("en-US", { notation: "compact", maximumFractionDigits: 1 });
const whole = new Intl.NumberFormat("en-US");

export const formatTokens = (value: number) => (value >= 10_000 ? compact.format(value) : whole.format(value));
export const formatCount = (value: number) => whole.format(value);

export const formatUsd = (value: number) => {
  if (value === 0) return "$0";
  if (value < 0.01) return "<$0.01";
  return `$${value.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

export const formatPerMTok = (value: number | null | undefined) =>
  value == null ? "—" : `$${value.toLocaleString("en-US", { maximumFractionDigits: 3 })}`;
